// generated from 103_643 samples

import { z } from "zod";

export const potentiallyEnteredWorkflowTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::PotentiallyEnteredWorkflow"),
});
